export default {
  ACTIVATE_INTERSECTING_ICON: 'iconButtons/ACTIVATE_INTERSECTING_ICON',
  DEACTIVATE_INTERSECTING_ICON: 'iconButtons/DEACTIVATE_INTERSECTING_ICON'
};
